import { CircularProgress, Link, List, ListItem, Typography } from '@mui/material';
import { ImportJobStatusName } from 'common/constants/admin';
import { ImportJobStatus } from 'common/types/Entities';

import { importAttemptCompleted } from '../utils/ImportsUtils';

export function ImportsDialogContents({
    importStatus,
    parsingErrors
} : Readonly<{importStatus: ImportJobStatus, parsingErrors: Array<string>}>) {
    return (
        <>
            {!importAttemptCompleted(importStatus.importStatusName) &&
                <CircularProgress data-testid='loading' sx={{ marginTop: '1rem' }}/>
            }
            {importStatus.importStatusName == ImportJobStatusName.PARSING_ERRORS
                && parsingErrors
                && parsingErrors.length > 0
                &&
                <>
                    <Typography color="info.light" fontWeight='550' marginTop='1rem'>
                        Issues:
                    </Typography>
                    <List sx={{ listStyleType: 'disc' }}>
                        {parsingErrors.map((error: string) => (
                            <ListItem sx={{ display: 'list-item' }} key={error}>
                                {error}
                            </ListItem>
                        ))}
                    </List>
                </>
            }
            {importStatus.importStatusName == ImportJobStatusName.IMPORT_ERRORS &&
                    <Link
                        href={importStatus.s3PreSignedKickbackUrl}
                        underline="hover"
                        marginTop='1rem'
                    >
                        Download kickback file for details
                    </Link>
            }
        </>
    );
}
